import { SagaMiddleware } from 'redux-saga';
import { all, call, spawn } from 'redux-saga/effects';

import {
  basketActions,
  basketReducer,
  basketSaga,
  basketSelectors,
  defaultBasketState,
} from './basket';
import {
  cookieConsentReducer,
  defaultCookieConsentState,
} from './cookie-consent/reducers';
import {
  defaultPaymentState,
  paymentActions,
  paymentSaga,
  paymentsReducer,
} from './payment';
import {
  defaultRouterState,
  routerActions,
  routerReducer,
  routerSaga,
} from './router';
import { userActions, userSaga } from './user';

export {
  basketActions,
  basketSelectors,
  paymentActions,
  routerActions,
  userActions,
};

export const defaultState = {
  basket: defaultBasketState,
  payments: defaultPaymentState,
  location: defaultRouterState,
  cookieConsent: defaultCookieConsentState,
};
export const reducers = {
  basket: basketReducer,
  payments: paymentsReducer,
  location: routerReducer,
  cookieConsent: cookieConsentReducer,
};

const isDev = process.env.REACT_APP_ENVIRONMENT === 'development';

function* rootSaga() {
  const sagas = [basketSaga, paymentSaga, routerSaga, userSaga];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            isDev && console.log('[ROOT_SAGA] STARTING', saga.name);
            yield call(saga);
            isDev && console.log('[ROOT_SAGA] STOPPING', saga.name);
            break;
          } catch (e) {
            isDev && console.warn('[ROOT_SAGA] ERROR', saga.name, e);
            console.error(e);
          }
        }
      }),
    ),
  );
}

export function initSaga(sagaMiddleware: SagaMiddleware<object>) {
  sagaMiddleware.run(rootSaga);
}
